<div class="tab-pane" role="tabpanel" id="cond_anteproy">
    <fieldset id="agregar_cond_anteproy" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal titulo">
                            <h3 class="form-signin-heading"><strong>Condicionantes del anteproyecto</strong></h3> 
                            <br />
                            <div class="form-group" align="left" style="padding-bottom: 20px; font-size: 13px">
                                <div class="col-sm-2"></div>

                                <div class="col-sm-10" class="inline">
                                    <div class="col-md-12" style="padding-bottom: 10px">
                                        <div class="col-md-3">
                                            <mat-checkbox (change)="add_cond_anteproy()" formControlName="fusion" name="fusion" value="SI">Fusi&oacute;n</mat-checkbox>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-checkbox (change)="add_cond_anteproy()" formControlName="subdivision" name="subdivision" value="SI">Subdivisi&oacute;n</mat-checkbox>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-checkbox (change)="add_cond_anteproy()" formControlName="estudio" name="estudio" value="SI">Estudio fundado por areas de riesgo (Art. 2.1.17 O.G.U.C.)</mat-checkbox>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding-top: 10px">
                                        <div class="col-md-6" align="left">
                                            <mat-checkbox (change)="add_cond_anteproy()" formControlName="edificacion" name="edificacion" value="SI">Edificaci&oacute;n</mat-checkbox>
                                        </div>
                                        <div class="col-md-6" align="left">
                                            <mat-checkbox (change)="add_cond_anteproy()" formControlName="otros" name="otros" value="SI">Otros (especificar)</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <br />
            </div>
        </div>

    </fieldset>
</div>
<div class="separator"></div>